export enum OutcomeAssignToTypes {
  Owner = 'Owner',
  Self = 'Self',
}
